import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const checkBoxLabelCss = (isHideQuizAnswersChecked) => ({
  alignItems: "flex-start",
  maxWidth: "calc(100vw - 32px)",
  width: "400px",
  padding: "0",
  color: isHideQuizAnswersChecked ? ui.neutral[700] : ui.neutral[500],
  outlineOffset: "4px",
});
